import { render, staticRenderFns } from "./PaymentHistory.vue?vue&type=template&id=2f81a645&scoped=true"
import script from "./PaymentHistory.vue?vue&type=script&lang=js"
export * from "./PaymentHistory.vue?vue&type=script&lang=js"
import style0 from "./PaymentHistory.vue?vue&type=style&index=0&id=2f81a645&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f81a645",
  null
  
)

export default component.exports